import { graphql, useStaticQuery } from '@amazeelabs/gatsby-plugin-operations';
import { SettingsNewsroomUrlQuery } from '@custom/schema';

export function useSettingsNewsroomUrlQuery() {
  return useStaticQuery(graphql(SettingsNewsroomUrlQuery));
}
